import Rails from "rails-ujs";
window.Rails = Rails;
Rails.start();

import moment from "moment/moment";

import "@hotwired/turbo-rails";

import LocalTime from "./lib/local_time";
window.LocalTime = LocalTime;

document.addEventListener("touchstart", () => {}, false);

moment.locale(document.documentElement.lang);

import "./channels";
import "./controllers";
import "../components/index";
